// Return an interface to get url params, using the given url, or the current window.location.search (if it exists).
// Falls back to mocking the URLSearchParams::get(key) API if window.URLSearchParams does not exist.
export const getNormalizedUrlParams = (url?, opts?) => { //lowercaseAll=true) => {

    // Browser default, if exists:
    if (typeof window !== 'undefined' && window.URLSearchParams) {
        const params = new URLSearchParams(url || window.location?.search);
        const normalParams = new URLSearchParams();
        if (params && typeof params[Symbol.iterator] === 'function') { // prevents error in some browsers?
            for (const [name, value] of params) {
                normalParams.append(opts?.lowercaseAll ? name.toLowerCase() : name, value);
            }
        }
        return normalParams;
    }

    // Fallback to mocking URLSearchParams::get(key) API:

    const queryStringToJSON = () => {
        url = url || location?.search;
        try {
            if (!url) return {};
            let pairs = url.slice(1).split('&');
            let result = {};
            pairs.forEach((pair: any) => {
                pair = pair.split('=');
                let k = pair[0].trim();
                if (!k) return;
                if (k[0] == '?') k = k.substring(1, k.length);
                // use default/given and silent fail if params have unknown encoding
                let v = pair[1];
                try { v = decodeURIComponent(pair[1] || '') } catch (e) { };
                result[k] = v;
            });
            return result;
        } catch (e) {
            console.log(`Error parsing query string to json, url: ${url}, error:`, e);
        }
    }

    return (() => {
        let params = queryStringToJSON();
        return {
            get: (key) => {
                return params ? params[key] : undefined;
            }
        }

    })();
}
